module.exports = __webpack_public_path__ + "static/img/news2_1.3d3046c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news2_1.jpg
// module id = uGWc
// module chunks = 0